import { getBlock } from "../service/getBlock";
import { IProduct } from "../views/ecommerce/products/interfaces";

export const getDetails = async (
    selectedProduct: IProduct,
    setDetails: any
): Promise<{
    isError: boolean,
    block: any
}> => {
    const { block, isError } = await getBlock("/branch/products/details", {
        productId: selectedProduct.id
    });

    setDetails(block.ProductDetails)

    return {
        isError: isError,
        block: block
    }
}